export * from './expandCollapse';
export * from './firstExpand';
export * from './startPrivateChat';

export const UPDATE_STYLE_PARAMS_COLORS = 'UPDATE_STYLE_PARAMS_COLORS';
export const UPDATE_STYLE_PARAMS_FONTS = 'UPDATE_STYLE_PARAMS_FONTS';
export const UPDATE_SITE_COLORS = 'UPDATE_SITE_COLORS';
export const UPDATE_DESIGN = 'UPDATE_DESIGN';
export const UPDATE_LAYOUT = 'UPDATE_LAYOUT';
export const UPDATE_TEXTS = 'UPDATE_TEXTS';
export const UPDATE_VISIBILITY_SETTINGS = 'UPDATE_VISIBILITY_SETTINGS';
export const UPDATE_VIEW_MODE = 'UPDATE_VIEW_MODE';
export const INIT_CHAT_SDK = 'INIT_CHAT_SDK';
export const UPDATE_BUSINESS_CHATROOM_ID = 'UPDATE_BUSINESS_CHATROOM_ID';
export const UPDATE_SHARD_ID = 'UPDATE_SHARD_ID';
export const UPDATE_CORRELATION_ID = 'UPDATE_CORRELATION_ID';
export const UPDATE_IS_CHAT_SDK_INIT = 'UPDATE_IS_CHAT_SDK_INIT';
export const UPDATE_CORE_CHAT_TOKEN = 'UPDATE_CORE_CHAT_TOKEN';
export const UPDATE_AVAILABILITY_STATUS = 'UPDATE_AVAILABILITY_STATUS';
export const UPDATE_IS_BRANDED = 'UPDATE_IS_BRANDED';
export const UPDATE_SOCIAL_ENABLED = 'UPDATE_SOCIAL_ENABLED';
export const UPDATE_BUSINESS_ENABLED = 'UPDATE_BUSINESS_ENABLED';
export const UPDATE_IS_EXPANDED = 'UPDATE_IS_EXPANDED';
export const SET_CURRENT_CHATROOM = 'SET_CURRENT_CHATROOM';
export const UPDATE_SHOW_SOCIAL_LIST_IN_EDITOR =
  'UPDATE_SHOW_SOCIAL_LIST_IN_EDITOR';
export const UPDATE_LEAD_CAPTURE_FORM_CONFIG =
  'UPDATE_LEAD_CAPTURE_FORM_CONFIG';
export const UPDATE_ALLOW_INPUT = 'UPDATE_ALLOW_INPUT';
export const UPDATE_HAS_MESSAGES = 'UPDATE_HAS_MESSAGES';
export const UPDATE_IS_LCF_MANDATORY = 'UPDATE_IS_LCF_MANDATORY';
export const UPDATE_EVER_EXPANDED = 'UPDATE_EVER_EXPANDED';
export const UPDATE_WAS_LEAD_CAPTURE_FORM_FILLED =
  'UPDATE_WAS_LEAD_CAPTURE_FORM_FILLED';
export const START_PRIVATE_CHAT = 'START_PRIVATE_CHAT';
export const FIREBASE_GO_OFFLINE = 'FIREBASE_GO_OFFLINE';

export * from './serverApi';

export function initChatSdk({ coreChatToken, isBusinessChat }) {
  return {
    type: INIT_CHAT_SDK,
    coreChatToken,
    isBusinessChat,
  };
}

export function updateSiteColors(colors) {
  return {
    type: UPDATE_SITE_COLORS,
    colors,
  };
}

export function updateStyleParamsColors(colors) {
  return {
    type: UPDATE_STYLE_PARAMS_COLORS,
    colors,
  };
}

export function updateStyleParamsFonts(fonts) {
  return {
    type: UPDATE_STYLE_PARAMS_FONTS,
    fonts,
  };
}

export function updateEditorSettingsDesign(design) {
  return {
    type: UPDATE_DESIGN,
    design,
  };
}

export function updateEditorSettingsLayout(layout) {
  return {
    type: UPDATE_LAYOUT,
    layout,
  };
}

export function updateEditorSettingsTexts(texts) {
  return {
    type: UPDATE_TEXTS,
    texts,
  };
}

export function updateVisibilitySettings(settings) {
  return {
    type: UPDATE_VISIBILITY_SETTINGS,
    settings,
  };
}

export function updateViewMode(viewMode) {
  return {
    type: UPDATE_VIEW_MODE,
    viewMode,
  };
}

export function updateBusinessChatRoomId(chatRoomId) {
  return {
    type: UPDATE_BUSINESS_CHATROOM_ID,
    chatRoomId,
  };
}

export function updateWasLeadCaptureFormFilled(wasLeadCaptureFormFilled) {
  return {
    type: UPDATE_WAS_LEAD_CAPTURE_FORM_FILLED,
    wasLeadCaptureFormFilled,
  };
}

export function updateShardId(shardId) {
  return {
    type: UPDATE_SHARD_ID,
    shardId,
  };
}

export function updateCorrelationId(correlationId) {
  return {
    type: UPDATE_CORRELATION_ID,
    correlationId,
  };
}

export function updateIsChatSdkInit(isInit) {
  return {
    type: UPDATE_IS_CHAT_SDK_INIT,
    isInit,
  };
}

export function updateCoreChatToken(coreChatToken) {
  return {
    type: UPDATE_CORE_CHAT_TOKEN,
    coreChatToken,
  };
}

export function updateAvailabilityStatus(availabilityStatus) {
  return {
    type: UPDATE_AVAILABILITY_STATUS,
    availabilityStatus,
  };
}

export function updateIsBranded(isBranded) {
  return {
    type: UPDATE_IS_BRANDED,
    isBranded,
  };
}

export function updateAllowInput(allowInput) {
  return {
    type: UPDATE_ALLOW_INPUT,
    allowInput,
  };
}

export function updateHasMessages(hasMessages) {
  return {
    type: UPDATE_HAS_MESSAGES,
    hasMessages,
  };
}

export function updateIsLcfMandatory(isLcfMandatory) {
  return {
    type: UPDATE_IS_LCF_MANDATORY,
    isLcfMandatory,
  };
}

export function updateSocialChatEnabled(enabled) {
  return {
    type: UPDATE_SOCIAL_ENABLED,
    enabled,
  };
}

export function updateBusinessChatEnabled(enabled) {
  return {
    type: UPDATE_BUSINESS_ENABLED,
    enabled,
  };
}

export function updateShowSocialListInEditor(shouldShow) {
  return {
    type: UPDATE_SHOW_SOCIAL_LIST_IN_EDITOR,
    shouldShow,
  };
}

export function updateIsWidgetExpanded(isExpanded) {
  return {
    type: UPDATE_IS_EXPANDED,
    isExpanded,
  };
}

export function setCurrentChatroom(chatroom) {
  return {
    type: SET_CURRENT_CHATROOM,
    chatroom,
  };
}

export function updateLeadCaptureFormConfig({ settings, url }) {
  return {
    type: UPDATE_LEAD_CAPTURE_FORM_CONFIG,
    url,
    settings,
  };
}

export function updateEverExpanded(everExpanded) {
  return {
    type: UPDATE_EVER_EXPANDED,
    everExpanded,
  };
}

export const goOffline = () => ({
  type: FIREBASE_GO_OFFLINE,
});
